var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-field-wrapper',{staticClass:"text-right bg-gray-100"},[_c('button',{staticClass:"button mr-2",on:{"click":_vm.cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('stateful-button',{staticClass:"button-primary",attrs:{"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.save}},[_vm._v("\n        Save & Close\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }